import { HISTORIAL_TYPES } from '../../constants/historial.types'

// ********************************************************************************************
export const setStatusModalAnular = (status: boolean) => ({
  type: HISTORIAL_TYPES.HISTORIAL_MODAL_ANULAR_STATUS,
  payload: status,
})

export const setStatusModalEnvio = (status: boolean) => ({
  type: HISTORIAL_TYPES.HISTORIAL_MODAL_EMAIL_STATUS,
  payload: status,
})

export const setStatusModalOpciones = (status: boolean) => ({
  type: HISTORIAL_TYPES.HISTORIAL_MODAL_OPTIONS_STATUS,
  payload: status,
})

export const setStatusModalImprimir = (status: boolean) => ({
  type: HISTORIAL_TYPES.HISTORIAL_MODAL_PRINT_STATUS,
  payload: status,
})

// ********************************************************************************************
export const setItemsFacturasAnular = (items: Array<any>) => ({
  type: HISTORIAL_TYPES.HISTORIAL_SET_ITEMS_ANULAR,
  payload: items,
})

export const setActiveHistorialFactura = (item: any) => ({
  type: HISTORIAL_TYPES.HISTORIAL_SET_ACTIVE_FACTURA,
  payload: item,
})

export const setQRFactura = (item: string | null) => ({
  type: HISTORIAL_TYPES.HISTORIAL_SET_QR,
  payload: item,
})

export const setAnuladoFactura = (flag: boolean) => ({
  type: HISTORIAL_TYPES.HISTORIAL_SET_ANULADO,
  payload: flag,
})

export const setResultAnulaciones = (item: Array<any>) => ({
  type: HISTORIAL_TYPES.HISTORIAL_SET_RESULT_ANULACIONES,
  payload: item,
})

export const setTiposDocumentos = (items: Array<any>) => ({
  type: HISTORIAL_TYPES.HISTORIAL_SET_TIPOS_DOCS,
  payload: items,
})

export const setResultFacturasFilter = (items: Array<any>) => ({
  type: HISTORIAL_TYPES.HISTORIAL_ARRAYRESULTADO,
  payload: items,
})

export const setResetHistorial = () => ({
  type: HISTORIAL_TYPES.HISTORIAL_RESET_ALL,
  payload: null,
})